module.exports = __webpack_public_path__ + "img/Car_of_the_month_DE.6f91a222.jpg";